<!-- 人员/部门/角色选择(本地弹窗) -->
<template>
  <div class="object-range" @click="visible = true">
    <span class="object-range-text text-color-plain text-normal-4 text-overflow-ellipsis">
      {{ rangeValueText || '全部部门' }}
    </span>
    <i
      class="icon-close-circle-fill object-range-clear t-iconfont"
      @click.stop="resetObjectRange"
    />
    <i class="icon-arrow-down-s-line object-range-arrow t-iconfont" />

    <PersonSelect
      v-model="rangeValueModel"
      v-model:show="visible"
      :max="max"
      :show-department="showDepartment"
      :show-role="showRole"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import PersonSelect from './person-select.vue'

defineOptions({
  name: 'AiPersonSelectV2'
})

const emits = defineEmits(['update:rangeValue', 'change', 'clear'])
const props = defineProps({
  rangeValue: {
    type: Array,
    default: () => []
  },
  max: {
    // 不传或传入 undefined 表示不限制选择数量；传入数字（包括 0）表示实际上限
    type: Number
  },
  showDepartment: {
    type: Boolean,
    default: true
  },
  showRole: {
    type: Boolean,
    default: false
  }
})

const visible = ref(false)

const rangeValueModel = computed({
  get() {
    return props.rangeValue
  },
  set(val) {
    emits('update:rangeValue', val)
    emits('change', val)
  }
})

const rangeValueText = computed(() => props.rangeValue.map((item) => item.name).join('、'))

const resetObjectRange = () => {
  rangeValueModel.value = []
  emits('clear', [])
}
</script>

<style lang="scss" scoped>
.object-range {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 8px;
  width: 96px !important;
  cursor: pointer;

  &-text {
    margin-right: 8px;
  }

  &-clear {
    display: none;
  }

  &-arrow {
    display: inline-block;
  }

  &:hover {
    .object-range-clear {
      display: inline-block;
    }

    .object-range-arrow {
      display: none;
    }
  }
}
</style>
